import React from 'react';
import KnowledgeBaseNameCell from './KnowledgeBaseNameCell';
import KnowledgeStatusBadge from './KnowledgeStatusBadge';
import SyncButton from './SyncButton';
import { SOURCE_TYPE_LABELS } from '../constants';
import { formatDate } from '../utils';

function KnowledgeBasesMobileList({
  items,
  syncingIds,
  deletingId,
  onSync,
  onDelete,
}) {
  return (
    <div className="md:hidden space-y-3">
      {items.map((kb) => {
        const sourceLabel = SOURCE_TYPE_LABELS[kb.source_type] || kb.source_type;
        const metaLine = `${sourceLabel} · ${kb.chunk_count ?? 0} chunks`;
        const updatedAt = kb.last_synced_at || kb.last_source_check_at;

        return (
          <div key={kb.id} className="surface-card p-4 space-y-3">
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0 flex-1">
                <KnowledgeBaseNameCell kb={kb} showSubtitle={false} />
              </div>
              <div className="shrink-0">
                <KnowledgeStatusBadge status={kb.status} />
              </div>
            </div>
            <p className="text-sm text-content-muted truncate" title={metaLine}>
              {metaLine}
            </p>
            {updatedAt && (
              <p className="text-xs text-content-subtle">
                Atualizado: {formatDate(updatedAt)}
              </p>
            )}
            <div className="flex items-center gap-3">
              <SyncButton
                kb={kb}
                isSyncing={Boolean(syncingIds[kb.id])}
                onSync={onSync}
              />
              <button
                type="button"
                onClick={() => onDelete(kb)}
                disabled={deletingId === kb.id}
                className="text-sm text-red-600 hover:text-red-800 disabled:opacity-50"
              >
                {deletingId === kb.id ? 'Excluindo...' : 'Excluir'}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default KnowledgeBasesMobileList;
